import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';
import { Fragment, useEffect, useState } from 'react';
import { MdOutlineTimer } from 'react-icons/md';
import { connect } from 'react-redux';
import { css } from 'twin.macro';

const TIMER_MINUTES = 10;

const Component = ({ conferenceSettings = {}, channelInfo = {} }) => {
    const [remainingMs, setRemainingMs] = useState(null);

    useEffect(() => {
        const startedAt = (channelInfo?.conferenceData || {})?.startedAt;
        if (!startedAt) return;
        const maxMinutes = conferenceSettings?.maxConferenceMinutes || 90;
        const startTime = new Date(startedAt).getTime();
        if (Number.isNaN(startTime)) return;

        const endTime = startTime + maxMinutes * 60 * 1000;
        const updateRemaining = () => setRemainingMs(endTime - Date.now());

        updateRemaining();
        const interval = setInterval(updateRemaining, 1000);
        return () => clearInterval(interval);
    }, [channelInfo, conferenceSettings?.maxConferenceMinutes]);

    return (
        <Fragment>
            {remainingMs !== null && remainingMs > 0 && remainingMs <= TIMER_MINUTES * 60 * 1000 && (
                <div
                    css={css`
                        background: #ff9800;
                        color: #fff;
                        padding: 0.5rem 0.75rem;
                        border-radius: 8px;
                        margin: 0.5rem auto 0.75rem;
                        font-weight: 600;
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;
                        text-align: center;
                        font-size: clamp(1.4rem, 4vw, 1rem);
                        max-width: fit-content;
                        width: 100%;
                        justify-content: center;
                    `}
                >
                    <MdOutlineTimer />
                    Meeting ends in {Math.max(0, Math.floor(remainingMs / 60000))}:
                    {`${Math.max(0, Math.floor((remainingMs % 60000) / 1000))
                        .toString()
                        .padStart(2, '0')}`}
                </div>
            )}
        </Fragment>
    );
};

const MeetingTimer = (props) => (
    <ComponentErrorBoundary>
        <Component {...props} />
    </ComponentErrorBoundary>
);

const mapStateToProps = (state) => ({
    conferenceSettings: state.conference?.conferenceSettings,
});

export default connect(mapStateToProps, {})(MeetingTimer);
